import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { PreliminaryYearResultWarningProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { SimpleMessage } from "components/common";
//#endregion
import { CurrencyHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const PreliminaryYearResultWarning: React.FC<PreliminaryYearResultWarningProps> = ({
  dividendAmount,
  maxAllowedDividend,
  preliminaryYearResult,
}) => {
  const result = (preliminaryYearResult ?? 0) + (maxAllowedDividend ?? 0) - (dividendAmount ?? 0);
  const hasNegativeResult = result < 0;

  return hasNegativeResult ? (
    <SimpleMessage
      icon={IconDefinitionConstants.WExclamation}
      displayType={StyleEnums.DisplayType.Warning}
      className={cssExports.v2}
    >
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.PreliminaryYearResultWarning, "", {
        preliminaryYearResult: CurrencyHelper.toRoundedDownSEK(preliminaryYearResult ?? 0),
      })}
    </SimpleMessage>
  ) : (
    <></>
  );
};

export default PreliminaryYearResultWarning;
